export default __webpack_public_path__ + "static/media/amazon-logo-m.92b26cb5.svg";